module.exports = __webpack_public_path__ + "img/facebook.f4c1a03b.jpg";